import React from 'react';

import { List as AntList } from 'antd';
import { ListProps } from 'antd/lib/list';

export interface IListProps<T> extends ListProps<T> {}

const InternalList = React.memo(function InternalList<T>(props: IListProps<T>) {
  return <AntList {...props}>{props.children}</AntList>;
});

export { InternalList };
